import type { LocationType } from '@sdk/locations/types/LocationType';

export const getLocationsWithoutAddress = (locations: LocationType[]): LocationType[] => {
  return locations.filter((location) => !location.address);
};
